import React from 'react'
import { Link } from 'react-router-dom'
import { FaGooglePlay, FaApple, FaDownload } from 'react-icons/fa'

function Footer() {
  const playStoreLink = "https://play.google.com/store/apps/details?id=com.ratnavali.app";
  const appStoreLink = "#"; // Add your App Store link here

  const handleDownloadClick = (store) => {
    if (store === 'playstore') {
      window.open(playStoreLink, '_blank');
    } else if (store === 'appstore') {
      window.open(appStoreLink, '_blank');
    }
  };

  return (
    <div>
      <footer className="" style={{paddingTop:"25px"}}>
        <div className="container">
          <div className="row mb-n7">
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                <a className="footer-brand" href="#">
                  <img width={80} src="/assets/images/logo/logo.jpeg" alt="images_not_found" />
                </a>
               
                
                <ul className="footer-des">
                  <li className="footer-des-list">
                    <i className="las la-envelope-open" />
                    <a href="mailto:logicalsofttech@gmail.com">logicalsofttech@gmail.com</a>
                  </li>
                  <li className="footer-des-list">
                    <i className="las la-phone-volume" />
                    <a href="tel:+911234567890">+91 1234567890</a>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                <h4 className="title mb-3" style={{color: '#160015', fontSize: '1.1rem'}}>Quick Links</h4>
                <ul className="footer-menu">
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/shop">Products</Link>
                  </li>
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/login">Login</Link>
                  </li>
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/aboutUs">About Us</Link>
                  </li>
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/contect_us">Contact Us</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                <h4 className="title mb-3" style={{color: '#160015', fontSize: '1.1rem'}}>Legal</h4>
                <ul className="footer-menu">
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/termsAndCondition">Terms & Conditions</Link>
                  </li>
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/privacyPolicy">Privacy Policy</Link>
                  </li>
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/refundPolicy">Refund Policy</Link>
                  </li>
                  <li className="footer-menu-items mb-2">
                    <Link className="footer-menu-link" to="/faq">FAQ</Link>
                  </li>
                </ul>
              </div>
            </div>
            
            <div className="col-lg-3 col-sm-6 mb-7">
              <div className="footer-widget">
                <h4 className="title mb-3" style={{color: '#160015', fontSize: '1.1rem'}}>Download Our App</h4>
                
                {/* Download App Section */}
                <div className="download-app-section mb-3">
                  <div className="download-btn-container">
                    {/* Google Play Store Button */}
                    <button 
                      onClick={() => handleDownloadClick('playstore')}
                      className="btn w-100 mb-2 d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: '#160015',
                        color: '#fee894',
                        border: '1px solid #160015',
                        borderRadius: '8px',
                        padding: '10px 15px',
                        fontSize: '14px',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#fee894';
                        e.currentTarget.style.color = '#160015';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#160015';
                        e.currentTarget.style.color = '#fee894';
                      }}
                    >
                      <FaGooglePlay style={{ marginRight: '8px', fontSize: '1.2rem' }} />
                      <div className="text-start">
                        <small style={{ fontSize: '10px', opacity: 0.9 }}>GET IT ON</small>
                        <div style={{ fontSize: '14px', fontWeight: '600' }}>Google Play</div>
                      </div>
                    </button>
                    
                    {/* App Store Button */}
                    <button 
                      onClick={() => handleDownloadClick('appstore')}
                      className="btn w-100 d-flex align-items-center justify-content-center"
                      style={{
                        backgroundColor: '#160015',
                        color: '#fee894',
                        border: '1px solid #160015',
                        borderRadius: '8px',
                        padding: '10px 15px',
                        fontSize: '14px',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#fee894';
                        e.currentTarget.style.color = '#160015';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#160015';
                        e.currentTarget.style.color = '#fee894';
                      }}
                    >
                      <FaApple style={{ marginRight: '8px', fontSize: '1.2rem' }} />
                      <div className="text-start">
                        <small style={{ fontSize: '10px', opacity: 0.9 }}>Download on the</small>
                        <div style={{ fontSize: '14px', fontWeight: '600' }}>App Store</div>
                      </div>
                    </button>
                  </div>
                  
                  
                </div>
                
                {/* Social Links */}
                <div className="social-links social-links-dark">
                  <h6 className="mr-2" >Follow Us</h6>
                  <div className="d-flex">
                    <a className="social-link facebook" href="#" >
                      <i className="lab la-facebook" />
                    </a>
                    <a className="social-link twitter" href="#" >
                      <i className="lab la-twitter" />
                    </a>
                    <a className="social-link youtube" href="#" >
                      <i className="lab la-youtube" />
                    </a>
                    <a className="social-link instagram" href="#" >
                      <i className="lab la-instagram" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Payment Methods */}
        <div className="container mt-4">
          <div className="row">
            <div className="col-12 text-center">
              <a className="footer-payment" href="#">
                <img src="/assets/images/payment/payment.png" alt="payment-methods" style={{maxWidth: '300px'}} />
              </a>
            </div>
          </div>
        </div>
        
        {/* Copyright Section */}
        <div className="copy-right mt-4" style={{backgroundColor: '#160015', color: '#fee894'}}>
          <div className="container">
            <div className="row">
              <div className="col-12 text-center py-3">
                <p className="mb-0">
                  © <span id="currentYear">{new Date().getFullYear()}</span> Made With
                  <i className="las la-heart mx-1" style={{color: '#fee894'}} /> By
                  <a href="#" className="ms-1" style={{color: '#fee894', textDecoration: 'underline'}}> RATNAVALLI </a>
                  All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Footer